module.exports = __webpack_public_path__ + "img/s3_v0.c5a94a68.png";